import { CardCarousel } from "@lululemon/ecom-cdp/src/components/card-carousel/card-carousel.js";
export default CardCarousel;
